import { API_VERSION } from "../../constants/AppVarConstants";

 //const BASE_URL = "http://seevi-dev-load-balancer-1158974966.eu-north-1.elb.amazonaws.com/seevi-api/";
  // const BASE_URL = "http://localhost:8080/";

//  const BASE_URL = "http://localhost:8080/";
// const BASE_URL = "http://192.168.29.103:8080/";
// const BASE_URL = "https://uat.seevi.in/seevi-api/";
// const BASE_URL = "http://10.156.134.79:8080/";
   const BASE_URL = "https://api.seevi.in/";

/** Public web app origin for share links (candidate profile, etc.). Trailing slash included. */
// const FRONTEND_BASE_URL = "http://localhost:3000/";
export const FRONTEND_BASE_URL =
  process.env.REACT_APP_FRONTEND_BASE_URL?.replace(/\/?$/, "/") || "https://api.seevi.in/";

/** Persist FCM device token. Push sends should use data-only: { data: { title, body } } so the SW shows one notification with the SeeVi logo. */
export const SAVE_FCM_TOKEN_URL = `${BASE_URL}api/push/save-token`;
export const NOTIFICATIONS_UNREAD_COUNT_URL = `${BASE_URL}api/notifications/unread-count`;
export const NOTIFICATIONS_LIST_URL = `${BASE_URL}api/notifications`;
export const NOTIFICATIONS_READ_ALL_URL = `${BASE_URL}api/notifications/read-all`;
export const NOTIFICATIONS_READ_URL = (notificationId: number | string) =>
  `${BASE_URL}api/notifications/${notificationId}/read`;

export const USER_LOGIN_URL = `${BASE_URL}auth/${API_VERSION}/login`;
export const USER_SIGNUP_URL = `${BASE_URL}auth/user/${API_VERSION}/sign-up`;

export const CREATE_USER_URL = `${BASE_URL}user/${API_VERSION}/create`;

/** National mobile number only (no country code); country code goes in POST body as `countryCode`. */
export const GET_OTP_URL = (nationalMobileNo: string) =>
  `${BASE_URL}auth/otp/${nationalMobileNo}/${API_VERSION}/send`;
export const VERIFY_OTP = `${BASE_URL}auth/otp/${API_VERSION}/verify`;

export const REFRESH_TOKEN_URL = `${BASE_URL}auth/token/${API_VERSION}/refresh`;

export const USER_LOGOUT_URL = `${BASE_URL}user/${API_VERSION}/logout`;
export const USER_ACCOUNT_DELETE_URL = `${BASE_URL}user/account/${API_VERSION}/delete`;
export const LOGOUT_URL = `${BASE_URL}auth/${API_VERSION}/logout`;

export const USER_PROFILE_URL = `${BASE_URL}user/detail/${API_VERSION}/read`;
export const USER_PROFILE_UPDATE_URL = `${BASE_URL}user/detail/${API_VERSION}/update`;
export const USER_PROFILE_EDIT_URL = `${BASE_URL}user/email-name/${API_VERSION}/edit`;

export const GET_MASTER_DATA = (field: string, query?: string) =>
  query
    ? `${BASE_URL}master-data/${field}/${API_VERSION}/read?${query}`
    : `${BASE_URL}master-data/${field}/${API_VERSION}/read`;

export const GET_DEGREE_MASTER_DATA = `${BASE_URL}master-data/DEGREE/${API_VERSION}/read`;

// Profile
export const GET_USER_DETAILS = (field: string) => `${BASE_URL}user/profile/${field}/${API_VERSION}/read`;
export const GET_USER_PROFILE_DETAILS = `${BASE_URL}user/profile/${API_VERSION}/read`;
export const USER_PROFILE_PREFERENCE = `${BASE_URL}user/profile/preferences/${API_VERSION}/read`;
export const USER_PROFILE_EXPERIENCE = `${BASE_URL}user/profile/experience/${API_VERSION}/read`;
export const USER_PROFILE_EDUCATION = `${BASE_URL}user/profile/education/${API_VERSION}/read`;
export const USER_PROFILE_CERTIFICATE = `${BASE_URL}user/profile/certificates/${API_VERSION}/read`;

export const USER_PROFILE_DETAILS_UPDATE_URL = `${BASE_URL}user/profile/${API_VERSION}/save`;
export const DELETE_USER_PROFILE_PICTURE_URL = `${BASE_URL}user/profile/profile-picture/${API_VERSION}/delete`;
export const USER_EXPERIENCE_UPDATE_URL = `${BASE_URL}user/profile/experience/${API_VERSION}/save`;
export const USER_EDUCATION_UPDATE_URL = `${BASE_URL}user/profile/education/${API_VERSION}/save`;
export const USER_CERTIFICATE_UPDATE_URL = `${BASE_URL}user/profile/certificates/${API_VERSION}/save`;
export const USER_PREFERENCE_UPDATE_URL = `${BASE_URL}user/profile/preferences/${API_VERSION}/save`;

// Media
export const IMAGE_UPLOAD_URL = `${BASE_URL}media/image/${API_VERSION}/upload`;
export const DOCUMENT_UPLOAD_URL = `${BASE_URL}media/document/${API_VERSION}/upload`;

// Jobs

export const GET_SKIPPED_JOBS = `${BASE_URL}user/jobs/skipped/${API_VERSION}/read`;
export const GET_SHORTLISTED_JOBS = `${BASE_URL}user/jobs/shortlisted/${API_VERSION}/read`;
export const GET_ALL_JOBS = `${BASE_URL}user/jobs/listing/${API_VERSION}/read`;
export const GET_APPLIED_JOBS = `${BASE_URL}user/jobs/applied/${API_VERSION}/read`;
export const GET_RECOMMENDED_JOBS = `${BASE_URL}user/jobs/recommended/${API_VERSION}/read`;
export const JOB_ACTION_URL = `${BASE_URL}user/jobs/action/${API_VERSION}/save`;
export const GET_JOB_DETAILS = (jobId: string) => `${BASE_URL}user/jobs/${jobId}/${API_VERSION}/read`;

export const USER_EXPERIENCE_EDIT_URL = `${BASE_URL}user/profile/experience/${API_VERSION}/edit`;
export const USER_EDUCATION_EDIT_URL = `${BASE_URL}user/profile/education/${API_VERSION}/edit`;
export const USER_CERTIFICATE_EDIT_URL = `${BASE_URL}user/profile/certificates/${API_VERSION}/edit`;
export const USER_PREFERENCE_EDIT_URL = `${BASE_URL}user/profile/preferences/${API_VERSION}/edit`;

export const ASSESSMENT_SAVE_URL = `${BASE_URL}assessment/answers/${API_VERSION}/save`;
export const ASSESSMENT_TPOIC_SCORE_URL = `${BASE_URL}assessment/user/topic/score/${API_VERSION}/read`;
export const ASSESSMENT_PERSONALITY_TYPE_URL = `${BASE_URL}assessment/user/personality/${API_VERSION}/read`;
export const ASSESSMENT_USER_BAND_URL = `${BASE_URL}assessment/score/band/${API_VERSION}/read`;
export const ASSESSMENT_READ_URL = `${BASE_URL}assessment/questions/${API_VERSION}/read`;

export const SAVE_USER_VIDEOS_URL = `${BASE_URL}video/user/answer/${API_VERSION}/save`;
export const GET_USER_VIDEOS_URL = `${BASE_URL}video/user/answer/${API_VERSION}/read`;
export const GET_VIDEO_QUESTIONS_URL = `${BASE_URL}video/question/master-data/${API_VERSION}/read`;
export const DELETE_USER_VIDEO = (questionId: any) => `${BASE_URL}video/user/${questionId}/${API_VERSION}/delete`;
export const REPLACE_USER_VIDEO = `${BASE_URL}video/user/answer/${API_VERSION}/update`;

export const GET_PRESIGNED_VIDEO_URL = `${BASE_URL}media/video/pre-signed-url/${API_VERSION}/read`;

// B2B

export const B2B_LOGIN_URL = `${BASE_URL}auth/b2b/${API_VERSION}/login`;
export const SIGNUP_ENQUIRY_URL = `${BASE_URL}auth/${API_VERSION}/signup-enquiry`;

export const CREATE_JOB_URL = `${BASE_URL}b2b/jobs/${API_VERSION}/create`;
export const EDIT_JOB_URL = `${BASE_URL}b2b/jobs/${API_VERSION}/edit`;

export const FIND_JOB_BY_ID_URL = (jobId: string) => `${BASE_URL}b2b/jobs/${jobId}/${API_VERSION}/read`;
export const B2B_JOB_DETAILS_URL = (jobId: string) => `${BASE_URL}b2b/jobs/${jobId}/${API_VERSION}/read`;
export const JOBS_LISTING_URL = `${BASE_URL}jobs/listing/${API_VERSION}/read`;
export const JOBS_LISTING_URL_EMPLOYER = `${BASE_URL}b2b/jobs/listing/${API_VERSION}/read`;
export const GET_JOB_APPLICANTS_URL = `${BASE_URL}b2b/jobs/applicants/${API_VERSION}/all`;
export const GET_SHARE_PROFILE_APPLICANTS_URL = (uniqueToken: string) => `${BASE_URL}b2b/jobs/profile/share-link/${uniqueToken}/${API_VERSION}/read`;
export const VALIDATE_SHARE_LINK_URL = `${BASE_URL}b2b/jobs/profile/share-link/validate/${API_VERSION}/read`;
export const VALIDATE_SHARE_PASSWORD_URL = `${BASE_URL}b2b/jobs/profile/share-link/validate-password/${API_VERSION}/read`;
export const UPDATE_JOB_ACTION_URL = `${BASE_URL}b2b/jobs/action/${API_VERSION}/save`;
export const UPDATE_BEST_FIT_URL = (applicationId: number) => `${BASE_URL}b2b/jobs/${applicationId}/best-fit/${API_VERSION}/update`;

// Comment API
export const CREATE_COMMENT_URL = `${BASE_URL}b2b/jobs/comment/${API_VERSION}/create`;
export const EDIT_COMMENT_URL = `${BASE_URL}b2b/jobs/comment/${API_VERSION}/edit`;
export const DELETE_COMMENT_URL = `${BASE_URL}b2b/jobs/comment/${API_VERSION}/delete`;
export const GET_COMMENTS_URL = `${BASE_URL}b2b/jobs/comments/${API_VERSION}/read`;
export const COMMENT_APPLICANT_VIEW_SAVE_URL = `${BASE_URL}b2b/jobs/comment/applicant/view/${API_VERSION}/create`;
export const UPDATE_JOB_STATUS_URL = (jobId: string, status: string) => `${BASE_URL}jobs/${jobId}/status/${API_VERSION}/update?status=${status}`;
export const GET_APPLICANT_DETAILS_URL = `${BASE_URL}b2b/jobs/applicant/detail/${API_VERSION}/read`;

export const EDIT_COMPANY_DETAILS_URL = `${BASE_URL}b2b/user/company/detail/${API_VERSION}/edit`;
export const USER_COMPANY_DETAILS_URL = `${BASE_URL}b2b/user/company/detail/${API_VERSION}/read`;
export const USER_COMPANY_CREATE_URL = `${BASE_URL}company/${API_VERSION}/create`;
export const GET_COMPANY_DETAILS_BY_ID_URL = (companyId: number) => `${BASE_URL}company/${companyId}/${API_VERSION}/read`;
export const UPDATE_COMPANY_DETAILS_BY_ID_URL = (companyId: number) => `${BASE_URL}company/${companyId}/${API_VERSION}/update`;
export const UPDATE_COMPANY_STATUS_URL = (companyId: number, status: string) => `${BASE_URL}company/${companyId}/status/${API_VERSION}/update?status=${status}`;

export const GET_PERSONALITY_URL = `${BASE_URL}master-data/personality-types/${API_VERSION}/read`;

export const B2B_TOPIC_SCORE = `${BASE_URL}b2b/jobs/applicant/topic/score/${API_VERSION}/read`;
export const B2B_SCORE_BAND = `${BASE_URL}b2b/jobs/applicant/score/band/${API_VERSION}/read`;
export const B2B_USER_PERSONALITY = `${BASE_URL}b2b/jobs/applicant/personality/${API_VERSION}/read`;

// Video Management

export const READ_USER_VIDEOS = `${BASE_URL}admin/user/videos/${API_VERSION}/all`;
export const UPDATE_USER_VIDEOS = `${BASE_URL}admin/user/video/status/${API_VERSION}/update`;

/** Retry / re-read video enhancement: GET admin/user/{mobileNo}/videos/v1/read (path version is fixed, not per-video) */
export const ADMIN_USER_VIDEO_ENHANCEMENT_RETRY_READ = (mobileNo: string) =>
  `${BASE_URL}admin/user/${encodeURIComponent(String(mobileNo))}/videos/v1/read`;

// Company List
export const COMPANY_LISTING_URL = `${BASE_URL}company/listing/${API_VERSION}/read`;
export const COMPANY_LISTING_LITE_URL = `${BASE_URL}company/listing/${API_VERSION}/read-lite`;
export const COMPANY_DELETE_URL = (companyId: number) => `${BASE_URL}company/${companyId}/${API_VERSION}/delete`;

// User List
export const USER_COMPANY_LISTING = (companyId: number) => `${BASE_URL}company/${companyId}/user/listing/${API_VERSION}/read`;
export const COMPANY_USER_LIST = `${BASE_URL}company/listing/${API_VERSION}/read-lite`;
export const CREATE_COMPANY_USER = (companyId: number) => `${BASE_URL}company/${companyId}/user/${API_VERSION}/create`;
export const UPDATE_COMPANY_USER = (userId: number, companyId: number) => `${BASE_URL}company/${companyId}/user/${userId}/${API_VERSION}/update`;
export const UPDATE_USER_STATUS = (userId: number, companyId: number, status: string) => `${BASE_URL}company/${companyId}/user/${userId}/status/${API_VERSION}/update?status=${status}`;
export const DELETE_COMPANY_USER = (userId: number, companyId: number) => `${BASE_URL}company/${companyId}/user/${userId}/${API_VERSION}/delete`;

// Reports
export const MONTHLY_REPORT_URL = `${BASE_URL}b2b/reports/user-activity/monthly/${API_VERSION}/read`;
export const CANDIDATE_REPORT_URL = `${BASE_URL}b2b/reports/candidate/${API_VERSION}/read`;
export const CLIENT_REPORT_URL = `${BASE_URL}b2b/reports/client/${API_VERSION}/read`;

// Share Candidate API
export const CREATE_SHARE_LINK_URL = `${BASE_URL}b2b/jobs/profile/share-link/${API_VERSION}/create`;

// Report API
export const GET_APPLICANT_REPORT_URL = (applicantId: number) => `${BASE_URL}b2b/jobs/applicant/detail/${API_VERSION}/read?applicant_id=${applicantId}`;

// Job Views API
export const SAVE_JOB_VIEWS_URL = `${BASE_URL}b2b/jobs/job-views/${API_VERSION}/save`;

// Organization Jobs API
export const GET_ORGANIZATION_JOBS_URL = (companyId: number) => `${BASE_URL}b2b/jobs/organization/${companyId}/jobs/${API_VERSION}/read`;

// Primary Status Update API
export const UPDATE_PRIMARY_STATUS_URL = `${BASE_URL}b2b/jobs/applicant/primary-status/${API_VERSION}/update`;

// Reachout Status Update API
export const UPDATE_REACHOUT_STATUS_URL = `${BASE_URL}b2b/jobs/applicant/reachout-status/${API_VERSION}/update`;


// Update Applicant View API
export const UPDATE_APPLICANT_VIEW_URL = `${BASE_URL}b2b/jobs/view-applicant/${API_VERSION}/update`;

// Recommend Job to Candidates API
export const RECOMMEND_JOB_TO_CANDIDATES_URL = `${BASE_URL}admin/job/recommendation/${API_VERSION}/create`;
export const GET_ALL_CANDIDATES_URL = `${BASE_URL}admin/candidates/${API_VERSION}/read`;
export const GET_B2B_SKILL_MASTER_DATA_URL = `${BASE_URL}master-data/b2b/SKILL/${API_VERSION}/read`;

// Active jobs dropdown for recommend popup (GET with optional search and companyId)
export const GET_JOBS_ACTIVE_DROPDOWN_URL = (search?: string, companyId?: number) => {
  const params = new URLSearchParams();
  if (search && search.trim()) params.set("search", search.trim());
  if (companyId != null && companyId > 0) params.set("companyId", String(companyId));
  const qs = params.toString();
  return `${BASE_URL}jobs/active/dropdown/${API_VERSION}/read${qs ? `?${qs}` : ""}`;
};
